import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
} from '@material-ui/core';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

import BillingInfo from './billing';
import PaymentInfo from './paymentInfo';
import PaymentStatus from './status';
import PolicyInfo from './policyInfo';
import styles from './styles';
import useStyles from '../shared/useStyles';
import { createPayment } from '../../core/api/payment';
import { successFetch } from '../../store/actions/app.action';

const Payment = () => {
  const stripe = useStripe();
  const elements = useElements();
  const classes = useStyles(styles);
  const dispatch = useDispatch();
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentError, setPaymentError] = useState('');

  // TODO: Consider using redux for this
  const [policyInfo, setPolicyInfo] = useState({ policy: '', amount: 0 });
  const [billingInfo, setBillingInfo] = useState({
    name: '',
    phone: '',
    address: '',
    city: '',
    state: 'KY',
    postalCode: '',
  });

  const [cardComplete, setCardComplete] = useState(false);
  const [isRaised, setIsRaised] = useState(false);

  const submit = async () => {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    setPaymentStatus('loading');

    // Create payment intent
    const clientSecretPromise = createPayment(
      policyInfo.amount,
      policyInfo.policy
    );
    const card = elements.getElement(CardElement);

    // Make payment
    let clientSecret;
    try {
      clientSecret = await clientSecretPromise;
      dispatch(successFetch());
    } catch (err) {
      // Error from our server
      setPaymentStatus('error');
      setPaymentError(err.response.data.msg);
      return;
    }

    const res = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card,
        billing_details: {
          name: billingInfo.name,
          phone: billingInfo.phone,
          address: {
            city: billingInfo.city,
            line1: billingInfo.address,
            state: billingInfo.state,
            postal_code: billingInfo.postalCode,
          },
        },
        metadata: {
          policyNum: policyInfo.policy,
        },
      },
    });

    if (res.error) {
      // There was an error processing payment
      console.error(res.error.message);
      setPaymentStatus('error');
      setPaymentError(res.error.message);
    } else {
      // Payment has been processed!
      if (res.paymentIntent.status === 'succeeded') {
        setPaymentStatus('success');
      } else if (res.paymentIntent.status === 'requires_capture') {
        setPaymentStatus('success');
      }
    }
  };

  const stripeChange = (e) => {
    if (e.complete && !cardComplete) {
      setCardComplete(true);
    } else if (!e.complete && cardComplete) {
      setCardComplete(false);
    }
  };

  const onNewPayment = () => {
    setPolicyInfo({ policy: '', amount: 0 });
    setPaymentStatus(false);
  };

  const onEditInfo = () => {
    setPaymentStatus(false);
  };

  return (
    <div className={classes.container}>
      <PaymentStatus
        status={paymentStatus}
        error={paymentError}
        onNewPayment={onNewPayment}
        submit={submit}
        editInfo={onEditInfo}
      />

      <Card
        className={classes.card}
        raised={isRaised}
        onFocus={() => setIsRaised(true)}
        onBlur={() => setIsRaised(false)}
      >
        <CardContent className={classes.content}>
          <Grid container spacing={6}>
            <Grid item sm={12}>
              <PolicyInfo info={policyInfo} setInfo={setPolicyInfo} />
            </Grid>

            <Grid item sm={12}>
              <BillingInfo info={billingInfo} setInfo={setBillingInfo} />
            </Grid>

            <Grid item xs={12}>
              <PaymentInfo onChange={stripeChange} />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions style={{ justifyContent: 'center' }}>
          <Button
            onClick={submit}
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            disabled={
              !(
                stripe &&
                elements &&
                cardComplete &&
                billingInfo.postalCode &&
                billingInfo.city &&
                billingInfo.address &&
                billingInfo.phone &&
                billingInfo.name &&
                policyInfo.policy &&
                policyInfo.amount
              )
            }
            className={classes.submitBtn}
          >
            Submit
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};
export default Payment;
